/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var e;!function(e){e[e.NeverApplied=0]="NeverApplied",e[e.Applied=1]="Applied",e[e.Undone=2]="Undone"}(e||(e={}));export{e as OperationStatus};
